export class WholesaleRequest {
    constructor(private dealerId: string, private dealerIdType: string, private modelYear: number
    , private regionalAllocationVehicleLineCode: string, private ptvl: string, private productionCycle: number, private allocationVehicleVolumeCommitCount: number, private specificationMarket: string, private wholesaleMonth: number, private isApproved: boolean){}
  } 